 class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );

    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const cartDrawerNote =
      this.querySelector('[id^="Details-"] summary');

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');

        trapFocus(
          containerToTrapFocusOn,
          focusElement
        );
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    // Restore customer's saved delivery choice
    // whenever the cart drawer opens.
    setTimeout(() => {
      pointureRestoreLocationStatus();
    }, 100);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );

    if (
      cartDrawerNote.nextElementSibling.getAttribute('id')
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener(
      'click',
      (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget
            .closest('details')
            .hasAttribute('open')
        );
      }
    );

    cartDrawerNote.parentElement.addEventListener(
      'keyup',
      onKeyUpEscape
    );
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner')
      .classList.contains('is-empty') &&
      this.querySelector('.drawer__inner')
        .classList.remove('is-empty');

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach(
      (section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;

        sectionElement.innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
      }
    );

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')
        .addEventListener(
          'click',
          this.close.bind(this)
        );

      this.open();

      // Shopify rebuilds the drawer after cart changes,
      // so restore Pointure delivery status again.
      setTimeout(() => {
        pointureRestoreLocationStatus();
      }, 100);
    });
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define(
  'cart-drawer',
  CartDrawer
);


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define(
  'cart-drawer-items',
  CartDrawerItems
);


// ======================================================
// POINTURE DELIVERY LOCATION SYSTEM
// ======================================================


// ------------------------------------------------------
// UI HELPERS
// ------------------------------------------------------

function pointureGetElements() {
  return {
    locationButton:
      document.querySelector(
        '#pointure-location-btn'
      ),

    otherButton:
      document.querySelector(
        '#pointure-other-location-btn'
      ),

    status:
      document.querySelector(
        '#pointure-location-status-drawer'
      ),

    checkoutButton:
      document.querySelector(
        '#CartDrawer-Checkout'
      )
  };
}


function pointureEnableCheckout() {
  const checkoutButton =
    document.querySelector(
      '#CartDrawer-Checkout'
    );

  if (!checkoutButton) return;

  checkoutButton.disabled = false;
  checkoutButton.removeAttribute('disabled');
  checkoutButton.textContent = 'CHECKOUT';
}


function pointureShowNormalStatus(message) {
  const status =
    document.querySelector(
      '#pointure-location-status-drawer'
    );

  if (!status) return;

  status.style.display = 'block';
  status.style.color = '#000000';
  status.style.background = 'transparent';
  status.style.border = '0';
  status.style.borderRadius = '0';
  status.style.padding = '8px 0';

  status.textContent = message;
}


function pointureShowError(message) {
  const status =
    document.querySelector(
      '#pointure-location-status-drawer'
    );

  if (!status) return;

  status.style.display = 'block';
  status.style.color = '#b00020';
  status.style.background = '#fff4f4';
  status.style.border =
    '1px solid #b00020';
  status.style.borderRadius = '6px';
  status.style.padding = '8px 10px';

  status.innerHTML = message;
}


function pointureShowSavedLocation(
  googleMapsUrl
) {
  const status =
    document.querySelector(
      '#pointure-location-status-drawer'
    );

  if (!status) return;

  status.style.display = 'block';
  status.style.color = '#008000';
  status.style.background = 'transparent';
  status.style.border = '0';
  status.style.borderRadius = '0';
  status.style.padding = '8px 0';

  status.innerHTML =
    '✅ <strong>Delivery Location Saved</strong><br>' +
    '<a href="' +
    googleMapsUrl +
    '" target="_blank" rel="noopener">' +
    'View location on Google Maps' +
    '</a>';
}


// ======================================================
// SAVE CURRENT GPS LOCATION
// ======================================================

// ======================================================
// GPS SUCCESS
// CUSTOMER ALLOWED LOCATION
// ======================================================

async function pointureLocationSuccess(position) {

  const {
    locationButton
  } = pointureGetElements();

  if (!locationButton) return;

  const latitude =
    position.coords.latitude;

  const longitude =
    position.coords.longitude;

  const googleMapsUrl =
    'https://www.google.com/maps?q=' +
    latitude +
    ',' +
    longitude;

  try {

    // Save customer's GPS into Shopify cart attributes
    const response = await fetch(
      '/cart/update.js',
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },

        body: JSON.stringify({
          attributes: {
            'Delivery Location Type':
              'Current Location',

            'Delivery Location':
              googleMapsUrl,

            'Delivery Latitude':
              latitude.toString(),

            'Delivery Longitude':
              longitude.toString()
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        'Could not save delivery location'
      );
    }

    // SUCCESS
    locationButton.disabled = false;

    locationButton.textContent =
      '📍 UPDATE MY DELIVERY LOCATION';

    pointureShowSavedLocation(
      googleMapsUrl
    );

    pointureEnableCheckout();

  } catch (error) {

    console.error(
      'POINTURE location save error:',
      error
    );

    locationButton.disabled = false;

    locationButton.textContent =
      '📍 SHARE MY DELIVERY LOCATION';

    pointureShowError(
      '⚠️ <strong>Your location was detected, but we could not save it.</strong><br>' +
      'Please try again.'
    );
  }
}


// ======================================================
// GPS ERROR
// ======================================================

function pointureLocationError(error) {

  const {
    locationButton
  } = pointureGetElements();

  if (!locationButton) return;

  console.log(
    'POINTURE GPS ERROR:',
    error.code,
    error.message
  );

  locationButton.disabled = false;

  locationButton.textContent =
    '📍 TRY LOCATION AGAIN';


  // ====================================================
  // CUSTOMER / BROWSER DID NOT GRANT LOCATION
  // ====================================================

  if (error.code === error.PERMISSION_DENIED) {

    pointureShowError(
      '⚠️ <strong>Location permission was not granted.</strong><br>' +
      'Please allow Pointure to use your location and tap Try Location Again.'
    );

    return;
  }


  // ====================================================
  // GPS POSITION UNAVAILABLE
  // ====================================================

  if (error.code === error.POSITION_UNAVAILABLE) {

    pointureShowError(
      '⚠️ <strong>Your location could not be detected.</strong><br>' +
      'Please make sure Location Services are enabled and try again.'
    );

    return;
  }


  // ====================================================
  // GPS TIMEOUT
  // ====================================================

  if (error.code === error.TIMEOUT) {

    pointureShowError(
      '⚠️ <strong>Location detection took too long.</strong><br>' +
      'Please tap Try Location Again.'
    );

    return;
  }


  // ====================================================
  // UNKNOWN GPS ERROR
  // ====================================================

  pointureShowError(
    '⚠️ We could not detect your location. Please try again.'
  );
}

// ======================================================
// CURRENT LOCATION BUTTON
//
// Delegated click listener is intentional because
// Shopify dynamically rebuilds the cart drawer.
// ======================================================

document.addEventListener('click', function (event) {

  const button = event.target.closest('#pointure-location-btn');

  if (!button) return;

  event.preventDefault();

  // IMPORTANT:
  // Start the GPS request directly from the customer's tap.
  // If Safari location permission is set to ASK,
  // Safari/iPhone can now show its native permission question.

  if (!navigator.geolocation) {
    pointureShowError(
      'Location sharing is not supported on this device.'
    );
    return;
  }

  button.disabled = true;
  button.textContent = '📍 GETTING YOUR LOCATION...';

  pointureShowNormalStatus(
    'Please allow location access when Safari asks.'
  );

  navigator.geolocation.getCurrentPosition(
    pointureLocationSuccess,
    pointureLocationError,
    {
      enableHighAccuracy: true,
      timeout: 20000,
      maximumAge: 0
    }
  );
});


// ======================================================
// DELIVER TO ANOTHER LOCATION
// ======================================================

async function pointureUseCheckoutAddress() {
  const {
    otherButton
  } = pointureGetElements();

  if (!otherButton) return;

  otherButton.disabled = true;

  pointureShowNormalStatus(
    'Preparing checkout...'
  );

  try {
    /*
     * Choosing checkout address clears any old
     * GPS coordinates from the Shopify cart.
     */
    const response =
      await fetch(
        '/cart/update.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body: JSON.stringify({
            attributes: {
              'Delivery Location Type':
                'Checkout Address',

              'Delivery Location': null,

              'Delivery Latitude': null,

              'Delivery Longitude': null
            }
          })
        }
      );

    if (!response.ok) {
      throw new Error(
        'Could not save delivery preference'
      );
    }

    otherButton.disabled = false;

    const status =
      document.querySelector(
        '#pointure-location-status-drawer'
      );

    if (status) {
      status.style.display = 'block';
      status.style.color = '#008000';
      status.style.background =
        'transparent';
      status.style.border = '0';
      status.style.borderRadius = '0';
      status.style.padding = '8px 0';

      status.textContent =
        '✓ Perfect. Enter your delivery address at checkout.';
    }

    pointureEnableCheckout();

  } catch (error) {
    console.error(
      'POINTURE delivery preference error:',
      error
    );

    otherButton.disabled = false;

    pointureShowError(
      '⚠️ Could not continue. Please try again.'
    );
  }
}


// ======================================================
// OTHER LOCATION BUTTON
// ======================================================

document.addEventListener(
  'click',
  function (event) {
    const button =
      event.target.closest(
        '#pointure-other-location-btn'
      );

    if (!button) return;

    event.preventDefault();

    pointureUseCheckoutAddress();
  }
);


// ======================================================
// RESTORE SAVED DELIVERY CHOICE
// ======================================================

async function pointureRestoreLocationStatus() {
  const {
    locationButton
  } = pointureGetElements();

  if (!locationButton) return;

  try {
    const response =
      await fetch(
        '/cart.js',
        {
          headers: {
            Accept:
              'application/json'
          }
        }
      );

    if (!response.ok) return;

    const cart =
      await response.json();

    const location =
      cart.attributes?.[
        'Delivery Location'
      ];

    const locationType =
      cart.attributes?.[
        'Delivery Location Type'
      ];


    // --------------------------------------------------
    // SAVED GPS LOCATION
    // --------------------------------------------------

    if (
      locationType ===
        'Current Location' &&
      location
    ) {
      locationButton.disabled = false;

      locationButton.textContent =
        '📍 UPDATE MY DELIVERY LOCATION';

      pointureShowSavedLocation(
        location
      );

      pointureEnableCheckout();

      return;
    }


    // --------------------------------------------------
    // CUSTOMER CHOSE CHECKOUT ADDRESS
    // --------------------------------------------------

    if (
      locationType ===
      'Checkout Address'
    ) {
      locationButton.disabled = false;

      locationButton.textContent =
        '📍 SHARE MY DELIVERY LOCATION';

      const status =
        document.querySelector(
          '#pointure-location-status-drawer'
        );

      if (status) {
        status.style.display = 'block';
        status.style.color = '#008000';
        status.style.background =
          'transparent';
        status.style.border = '0';
        status.style.borderRadius = '0';
        status.style.padding = '8px 0';

        status.textContent =
          '✓ Enter your delivery address at checkout.';
      }

      pointureEnableCheckout();

      return;
    }


    // --------------------------------------------------
    // NO DELIVERY CHOICE YET
    // --------------------------------------------------

    locationButton.disabled = false;

    locationButton.textContent =
      '📍 SHARE MY DELIVERY LOCATION';

  } catch (error) {
    console.error(
      'Could not restore delivery location:',
      error
    );
  }
}


// ======================================================
// INITIAL PAGE LOAD
// ======================================================

document.addEventListener(
  'DOMContentLoaded',
  function () {
    pointureRestoreLocationStatus();
  }
);